<template>
  <div>
    <!-- TABS -->
    <b-tabs>
      <b-tab title="Ready" active lazy>
        <so-ready-tab @addToInvoice="onAddToInvoice" @onSelectedSchedule="scheduleSelectedId = $event" />
      </b-tab>
      <b-tab title="Past Due" lazy :active="routerHash == '#pastDue'">
        <so-past-due-tab @addToInvoice="onAddToInvoice" @onSelectedSchedule="scheduleSelectedId = $event" />
      </b-tab>
      <b-tab title="Not Scheduled" lazy>
        <so-not-scheduled-tab @addToInvoice="onAddToInvoice" @onSelectedSchedule="scheduleSelectedId = $event" />
      </b-tab>
    </b-tabs>

    <!-- MODAL -->
    <add-to-invoice-modal :companyId="companyId" :SOLine="invoiceCandidate" @saved="redirectInvoice" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import SoReadyTab from './tabs/ReadyTab';
import SoPastDueTab from './tabs/PastDueTab';
import SoNotScheduledTab from './tabs/NotScheduledTab';
import AddToInvoiceModal from '@/pages/Invoices/components/add/AddToOpenInvoice';
import PickListModal from '@/shared/components/PickList';
import { filter } from 'minimatch';

export default {
  components: {
    SoReadyTab,
    SoPastDueTab,
    SoNotScheduledTab,
    AddToInvoiceModal,
    PickListModal
  },
  data() {
    return {
      invoiceCandidate: {},
      scheduledObj: {},
      pickTicketList: [],
      pickTicketListName: null,
      companyId: 0,
      scheduleSelectedId: 0
    }
  },
  computed: {
    routerHash() {
      return this.$route.hash;
    },  
  }, 
  methods: {
    onAddToInvoice(data) {
      // Creating an object to use for creating new invoice then add as an array
      this.companyId = data.companyId;
      this.invoiceCandidate = {
        id: data.salesOrderLineId,
        salesOrderId: data.salesOrderId,
        companyId: data.companyId,
        contactId: data.contactId,
        scheduleId: this.scheduleSelectedId
      };
      this.$bvModal.show('add-to-invoice-modal');
    },
    redirectInvoice(invoiceId)
    {
      
      let routeInvoice = this.$router.resolve({
        name: 'invoices.edit',
        params: { id:invoiceId },
        query: { openCharge: true }
      });

      this.$emit('onRedirect', routeInvoice);
      window.open(routeInvoice.href, '_blank');

    }
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>